module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-top": "25px"
    }
  }, [_c('div', {
    staticClass: "top-tips m-b-20"
  }, [_vm._v("最后请完善您的账号信息")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("微信号")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "qr-tips"
  }, [_vm._v("打开微信扫描验证码完成验证")]), _vm._v(" "), _c('div', {
    staticClass: "qr"
  }, [_c('wechartQR', {
    attrs: {
      "id": "login_container",
      "redirect-path": "/register/step",
      "query": {
        password: _vm.password,
        repassword: _vm.repassword
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("设置登录密码")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "reg-inp",
    attrs: {
      "type": "password",
      "placeholder": "请输入登录密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": _vm.pwdblur,
      "change": function($event) {
        _vm.setStorage('reg_password', _vm.password)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("再次输入密码")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repassword),
      expression: "repassword"
    }],
    staticClass: "reg-inp",
    attrs: {
      "type": "password",
      "placeholder": "再次输入密码"
    },
    domProps: {
      "value": (_vm.repassword)
    },
    on: {
      "blur": _vm.repwdblur,
      "change": function($event) {
        _vm.setStorage('reg_repassword', _vm.repassword)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repassword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pwderror || _vm.repwderror))])])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _vm._v(" "), _c('label', {
    staticClass: "value flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isagree),
      expression: "isagree"
    }],
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isagree) ? _vm._i(_vm.isagree, null) > -1 : (_vm.isagree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isagree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isagree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isagree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isagree = $$c
        }
      }
    }
  }), _vm._v("我已阅读并同意《在他乡服务协议》及《在他乡隐私声明》\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "label"
  }), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.hrReg
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-525f0dc9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/stepone.vue
// module id = 877
// module chunks = 1